export default __webpack_public_path__ + "static/media/twitter.6aab24d2.svg";